import React from 'react';
import { Box } from '@mui/material';
import { exchangeSpecificStringifiedNumber } from '../../../services/exchanges';

const formatTimestampToTime = (timestamp) => {
  if (!timestamp) return 'Invalid Time';
  const date = new Date(timestamp * 1000);
  return `${date.getHours().toString().padStart(2, '0')}:${date
    .getMinutes()
    .toString()
    .padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
};

const MarketDepthContent = ({ instrument }) => {
  const formatValue = (value) => {
    return value ? exchangeSpecificStringifiedNumber(instrument.exchange, value) : '-';
  };

  return (
    <Box sx={{ width: '100%', fontSize: '0.75rem' }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(5, 1fr)",
          gap: 1,
          p: 1,
          backgroundColor: "action.hover",
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <Box>
          <Box sx={{ color: "text.secondary" }}>Open</Box>
          <Box>{formatValue(instrument.openPrice)}</Box>
        </Box>
        <Box>
          <Box sx={{ color: "text.secondary" }}>High</Box>
          <Box>{formatValue(instrument.highPrice)}</Box>
        </Box>
        <Box>
          <Box sx={{ color: "text.secondary" }}>Low</Box>
          <Box>{formatValue(instrument.lowPrice)}</Box>
        </Box>
        <Box>
          <Box sx={{ color: "text.secondary" }}>Close</Box>
          <Box>{formatValue(instrument.closePrice)}</Box>
        </Box>
        <Box>
          <Box sx={{ color: "text.secondary" }}>Volume</Box>
          <Box>{instrument.volume || '-'}</Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(5, 1fr)",
          gap: 1,
          p: 1,
          backgroundColor: "action.hover",
          fontSize: '0.75rem'
        }}
      >
        <Box>
          <Box sx={{ color: "text.secondary" }}>Best bid</Box>
          <Box>{formatValue(instrument.bestBidPrice)}</Box>
        </Box>
        <Box>
          <Box sx={{ color: "text.secondary" }}>Bid Qty</Box>
          <Box>{instrument.bestBidQuantity || '-'}</Box>
        </Box>
        <Box>
          <Box sx={{ color: "text.secondary" }}>Best ask</Box>
          <Box>{formatValue(instrument.bestAskPrice)}</Box>
        </Box>
        <Box>
          <Box sx={{ color: "text.secondary" }}>Ask Qty</Box>
          <Box>{instrument.bestAskQuantity || '-'}</Box>
        </Box>
        <Box>
          <Box sx={{ color: "text.secondary" }}>LTT</Box>
          <Box>{formatTimestampToTime(instrument.ltt)}</Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MarketDepthContent; 